export const fieldLabels = {
  agreeCurrentCompliant: 'Agree with AO current compliance declaration',
  agreeFutureCompliant: 'Agree with AO future compliance declaration',
  annualFixedCosts: 'Annual fixed operating costs:',
  cashInHand: 'Cash at bank and in hand',
  closeReason: 'Reason',
  closureStatus: 'Closure status - KLOE',
  closureStatusRationale: 'Closing status rationale',
  closingStatus: 'Closing status',
  complianceClosureStatus: 'Closure status - compliance',
  complianceDisagreement: 'Reasons for disagreement with compliance declaration',
  complianceDisagreementDescription: 'Reasons for disagreement description',
  complianceFollowUp: 'Follow up - compliance',
  complianceFollowUpStatus: 'Follow up status - compliance',
  complianceRagRating: 'RAG rating - compliance',
  currentCompliant: "Complete the following declaration in relation to your organisation's current compliance.",
  currentCompliantDate: 'Please select the date by which you will become compliant.',
  currentCompliantNo: 'We are not currently compliant with all Conditions of Recognition.',
  currentCompliantYes: 'We are currently compliant with all Conditions of Recognition.',
  currentNonComplianceDescription: 'Please describe the instance of non-compliance',
  currentNonComplianceMitigation: 'Please describe how you plan to address this non-compliance.',
  endpointAssessmentClosureStatus: 'End Point Assessment closure status',
  eventType: 'Event type',
  followUp: 'Follow up - KLOE',
  followUpLead: 'Follow up lead',
  followUpStatus: 'Follow up status - KLOE',
  fullAccountsUpload: 'Can you upload your full accounts for your financial year that ended in 2024 that includes a profit & loss statement, full balance sheet and notes?',
  fullAccountsUploadEndJanuary: 'No, our year end is in October and we will upload our accounts to the message chain by 31 January 2025',
  fullAccountsUploadEndFebruary: 'No, our year end is in November and we will upload our accounts to the message chain by 28 February 2025',
  fullAccountsUploadEndMarch: 'No, our year end is in December and we will upload our accounts to the message chain by 31 March 2025',
  fullAccountsUploadNoCircumstances: 'No, there are exceptional circumstances and we have agreed a timeline to upload with our regulators',
  fullAccountsUploadYes: 'Yes',
  lead: 'Lead - KLOE',
  meetingDate: 'Event meeting date',
  netProfit: 'Net Surplus / Profit',
  nonComplianceNonOfqualConditions: 'Please list any Qualification Wales, CCEA Regulation or Ofqual Special Conditions here.',
  organisationalStabilityRagRating: 'RAG rating - organisational stability',
  organisationFollowUp: 'Organisation follow up',
  organisationFollowUpStatus: 'Organisation follow up status',
  overallRagRating: 'Overall RAG rating',
  ragRating: 'Rag rating - KLOE',
  regComplianceClosureStatus: 'Regulatory Compliance closure status',
  riskMarketsClosureStatus: 'Risk and Markets closure status',
  totalExpenditure: 'Total expenditure',
  totalRevenue: 'Total Income / Revenue',
  futureCompliant: "Complete the following declaration in relation to your organisation's future compliance.",
  futureCompliantYes: "We believe that we are likely to be compliant in the next 12 months with all Conditions of Recognition.",
  futureCompliantNo: "We believe that we are likely to fail to fully comply with all Conditions of Recognition in the next 12 months.",
  futureNonComplianceDescription: "Please describe the instance of potential non-compliance.",
  futureNonComplianceHow: "Please explain how you know you are likely to fail to comply.",
  futureNonComplianceMitigation: "Please describe how you plan to address this potential non-compliance.",
  closingStatusRationale: "Closing status rationale",
  govBodyConfirmCompliance: "1. I confirm that the Statement of Compliance is accurate.",
  govBodyNoCompliance: "Non compliance statement",
  govBodyConfirmApproval:" 2. I confirm our Governing Body has formally approved the Statement of Compliance submission. I also confirm that, if requested, I am able to produce documents to verify that the Statement of Compliance was formally approved by the Governing Body.",
  govBodyConfirmNoApproval: "Non approval statement",
  govBodyConfirmChairRo: "3. Please confirm that both the Chair of the Governing Body and the Responsible Officer have signed off the Statement of Compliance submission. I also confirm that, if requested, I am able to produce documents to verify that the Statement of Compliance submission has been signed off by the Chair of the Governing Body and the Responsible Officer).",
  govBodyConfirmNoChairRo: "Non conformity statement",
  govBodyConfirmNameRo: "Please confirm the name of the Responsible Officer that signed off the Statement of Compliance:",
  govBodyConfirmNameChair: "Please confirm the name of the Chair of your Governing Body that signed off the Statement of Compliance:",
  FullAccountsUploadDescription: "Please provide full details"
};
